import { useEffect } from 'react';
import { FaInfo } from 'react-icons/fa';
import Dropdown from 'react-bootstrap/Dropdown';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { push, useRouteMatch } from '../../app/route';
import {
  selectCurrentTenantId,
} from '../user/userSlice';
import {
  selectClientsAndActions,
  listClientsAction,
  deleteClientAction,
  updateClientAction,
  getClientListUrl,
  getClientCreateUrl,
  getClientDetailUrl,
} from './clientSlice';

type PathParams = {
  tenant_id: string;
};

export function ClientListPage() {
  const dispatch = useAppDispatch();
  const clients = useAppSelector(selectClientsAndActions);
  const tenant_id = useAppSelector(selectCurrentTenantId);
  const match = useRouteMatch<PathParams>();
  useEffect(() => {
    if (match.params.tenant_id !== tenant_id) {
      dispatch(push(getClientListUrl(tenant_id)));
    }
  }, [tenant_id, match, dispatch]);
  useEffect(() => {
    dispatch(listClientsAction({ tenant_id }));
  }, [tenant_id, dispatch]);

  const goDetail = (mode: 'view'|'edit', client_name: string) => {
    dispatch(push(getClientDetailUrl(tenant_id, client_name, mode)));
  };
  const goCreate = () => {
    dispatch(push(getClientCreateUrl(tenant_id)));
  };
  const handleDeleteClient = async(client_name: string) => {
    let result = await dispatch(deleteClientAction({
      tenant_id,
      client_name
    }));
    if (deleteClientAction.fulfilled.match(result)) {
      dispatch(listClientsAction({ tenant_id }));
    }
  };
  const handleEnableClient = async(client_name: string) => {
    let result = await dispatch(updateClientAction({
      tenant_id,
      client_name,
      body: { state: 'enabled' },
    }));
    if (updateClientAction.fulfilled.match(result)) {
      dispatch(listClientsAction({ tenant_id }));
    }
  };
  const handleDisableClient = async(client_name: string) => {
    let result = await dispatch(updateClientAction({
      tenant_id,
      client_name,
      body: { state: 'disabled' },
    }));
    if (updateClientAction.fulfilled.match(result)) {
      dispatch(listClientsAction({ tenant_id }));
    }
  };
  return (
    <div className="container">
      <div className="d-flex justify-content-between py-4">
        <h1>Client</h1>
        <button className="btn btn-primary my-2" onClick={() => goCreate()}>
          Create
        </button>
      </div>
      <table className="table">
        <thead className="table-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">ClientId</th>
            <th scope="col">State</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {clients.map((client, index) => {
            return (
              <tr key={index}>
                <th scope="row">{ index+1 }</th>
                <td>{client.name}</td>
                <td>{client.client_id}</td>
                <td>{client.state}</td>
                <td>
                  <Dropdown>
                    <Dropdown.Toggle variant="dark" id={'action-'+index}>
                      <FaInfo/>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      { client.$action.can_enable && 
                        <Dropdown.Item onClick={() => handleEnableClient(client.name)}>Enable</Dropdown.Item>
                      }
                      { client.$action.can_disable &&
                        <Dropdown.Item onClick={() => handleDisableClient(client.name)}>Disable</Dropdown.Item>
                      }
                      { client.$action.can_edit &&
                        <Dropdown.Item onClick={() => goDetail('edit', client.name)}>Edit</Dropdown.Item>
                      }
                      { client.$action.can_view &&
                        <Dropdown.Item onClick={() => goDetail('view', client.name)}>View</Dropdown.Item>
                      }
                      { client.$action.can_delete &&
                        <Dropdown.Item onClick={() => handleDeleteClient(client.name)}>Delete</Dropdown.Item>
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
